import {
    Datagrid,
    DateField,
    DateInput,
    FilterButton,
    List,
    TextField,
    TextInput,
    TopToolbar
} from "react-admin";
import { useClientContext } from "contexts/client";
import ExportButton from 'custom_components/CSVExportButton';

const statusLogFilters = [
    <TextInput label="MSID" source="master_customer_id" />,
    <TextInput label="Old Status" source="old_status" />,
    <TextInput label="New Status" source="new_status" />,
    <TextInput label="Changed By" source="changed_by" />, 
    <DateInput label="Date Added" source="date_added" />
];

const ListActions = () => {

    const {state} = useClientContext();

    return (
        <TopToolbar >
            <FilterButton/>
            <ExportButton resource={`${state.client.resourcePrefix}_store_status_log`}/>
        </TopToolbar>
    )
}

export const StoreStatusLogList = (props) => {

    const postRowClick = (id, resource, record) => (`/onpoint_master_customers/${record.master_customer_id}`);

    return (
        <List
            {...props}
            title="Store Status Log"
            filters={statusLogFilters}
            actions={<ListActions/>}
        >
            <Datagrid rowClick={postRowClick} bulkActionButtons={false}>
                <TextField source="master_customer_id" label="MSID" />
                <TextField source="changed_by" />
                <TextField source="old_status" />
                <TextField source="new_status" />
                <DateField source="date_added" />
            </Datagrid>
        </List>
    );
};

export default StoreStatusLogList;
